
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/national-merit",
      function () {
        return require("private-next-pages/national-merit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/national-merit"])
      });
    }
  